import HttpFactory from "~/repository/factory";
import { ENDPOINTS } from "~/repository/endpoints";
import type {
  AcceptSubscriptionRetentionOfferRequest,
  CancelSubscriptionInput,
  SubscriptionPlanResponse,
  SubscriptionResponse,
  UserSubscriptionResponse,
} from "~/types/payment";

class SubscriptionModule extends HttpFactory {
  async getSubscription(): Promise<SubscriptionResponse> {
    return await this.get(`${ENDPOINTS.PAYMENT.USER_SUBSCRIPTION}`);
  }

  async getSubscriptionPlan(id: number): Promise<SubscriptionPlanResponse> {
    return await this.get(`${ENDPOINTS.PAYMENT.SUBSCRIPTION_PLANS}${id}/`);
  }

  async cancelSubscription(data: CancelSubscriptionInput = {}): Promise<void> {
    return await this.post(`${ENDPOINTS.PAYMENT.CANCEL_SUBSCRIPTION}`, data);
  }

  async acceptCancelSubscriptionRetentionOffer(
    data: AcceptSubscriptionRetentionOfferRequest,
  ): Promise<UserSubscriptionResponse> {
    return await this.post(
      `${ENDPOINTS.PAYMENT.CANCEL_SUBSCRIPTION_RETENTION_OFFER_ACCEPT}`,
      data,
    );
  }

  async updateSubscriptionCreditCard(cardToken: string): Promise<void> {
    return await this.post(
      `${ENDPOINTS.PAYMENT.UPDATE_SUBSCRIPTION_CREDIT_CARD}`,
      {
        card_token: cardToken,
      },
    );
  }
}

export default SubscriptionModule;
